import { object, string } from 'yup';

export const validation = object({
  mfaCode: string().required('Please enter the code'),
});
